import { useEffect, type ReactNode } from "react";
import { LoggerFactory } from "@src/infrastructure/services/logger/logger.factory";

interface ILoggerProviderProps {
  children: ReactNode;
}

export const LoggerProvider: React.FC<ILoggerProviderProps> = ({
  children,
}) => {
  useEffect(() => {
    LoggerFactory.getInstance();
  }, []);
  return children;
};
